import React, { memo, useEffect, Fragment, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './MallOrderCard.module.less';
import copy from 'copy-to-clipboard';
import Toast from '../../../../components/Toast/Toast';
import Default from '../../../../static/order_default_app_icon.svg';
import { gameCDKCodeVisible } from '../../../../actions/gamecdk';
import { logging, logPostInfo } from '../../../../actions/log';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default memo(({ info }) => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);

  const [validImg, setValidImg] = useState(info.logo);

  const statusValList = {
    2: '支付成功',
    3: '充值中',
    5: '充值失败',
    8: '已退款',
  };

  const handleCopye = text => {
    copy(text);
    Toast.success({ content: '复制成功' });
  };

  const handleGameCdkShow = useCallback(info => {
    dispatch(
      logging({
        category: 'C',
        action: 'View_Cdkey',
        label: '',
        param2: {
          source: 'Orders',
          source_p: logInfoData.source,
          source_pp: logInfoData.source_p,
        },
      }),
    );
    dispatch(
      gameCDKCodeVisible({
        isShow: true,
        exchangeUrl: info.exchangeUrl,
      }),
    );
  }, []);

  return (
    <div className={styles.mall_orders_card}>
      <div className={styles.card_header}>
        <div className={styles.name_icon}>
          <img src={validImg || Default} onError={() => setValidImg(Default)} />
        </div>
        <div className={styles.name}>{info.sname}</div>
      </div>
      <div className={styles.card_info}>
        <>
          <div className={styles.card_info_item}>
            <div className={styles.info_item_name}>{'订单号'}</div>
            <div className={styles.info_item_content}>{info?.oid || ''}</div>
          </div>
          <div className={styles.card_info_item}>
            <div className={styles.info_item_name}>{'商品类型'}</div>
            <div className={styles.info_item_content}>
              {info.stypeVal === 1 && '直冲'}
              {info.stypeVal === 2 && '卡密'}
            </div>
          </div>
          <div className={styles.card_info_item}>
            <div className={styles.info_item_name}>{'支付时间'}</div>
            <div className={styles.info_item_content}>{info?.createTime || ''}</div>
          </div>
          {info.stypeVal === 1 && (
            <div className={styles.card_info_item}>
              <div className={styles.info_item_name}>{'充值账号'}</div>
              <div className={styles.info_item_content}>{info?.account || ''}</div>
            </div>
          )}
          {/* orderSource: 1: 联想支付，  2:凤凰支付 */}
          {info.stypeVal === 2 && info.orderSource === '1' && (
            <div className={styles.card_info_item}>
              <div className={styles.info_item_name}>{'卡密'}</div>
              <>
                <div className={styles.info_item_content}>{info?.code}</div>
                <div className={styles.info_copy} onClick={() => handleCopye(info?.code)}>
                  复制
                </div>
              </>
            </div>
          )}
          {info.stypeVal === 2 && info.orderSource === '2' && (
            <div className={styles.card_info_item}>
              <div className={styles.info_item_name}>{'卡密'}</div>
              {info?.exchangeUrl && (
                <div
                  className={styles.info_item_content_link}
                  onClick={() => {
                    handleGameCdkShow(info);
                  }}
                >
                  点击此处查看激活码
                </div>
              )}
              {!info?.exchangeUrl && (
                <div className={styles.info_item_content}>{'激活码分配中，请等待...'}</div>
              )}
            </div>
          )}

          {!(info.stypeVal === 2 && info.orderSource === '2') && (
            <div className={styles.card_info_item}>
              <div className={styles.info_item_name}>{'订单状态'}</div>
              <div className={styles.info_item_content}>{statusValList[info?.statusVal || 2]}</div>
            </div>
          )}
          {info.stypeVal === 2 && info.orderSource === '2' && (
            <div className={styles.card_info_item}>
              <div className={styles.info_item_name}>{'订单金额'}</div>
              <div className={styles.info_item_content}>{info?.payPrice}元</div>
            </div>
          )}
          {!(info.stypeVal === 2 && info.orderSource === '2') && info?.expire && (
            <div className={styles.card_info_item}>
              <div className={styles.info_item_name}>{'卡密有效期'}</div>
              <div className={styles.info_item_content}>{info?.expire || ''}</div>
            </div>
          )}
        </>
      </div>
    </div>
  );
});
